import { TFunction } from 'next-i18next';

import { LangUri } from '@catawiki/runtime-toolkit';
import { RFC4646Locale } from '@catawiki/locale';

import { sellerSuccessFeeHelpUrl } from '@/shared/constants/routes';

export const getFAQs = (t: TFunction, locale: RFC4646Locale) => [
  {
    title: t('seller_register.faq.what_objects_title'),
    content: t('seller_register.faq.what_objects_content'),
    link: LangUri.generateLocalePath(
      locale,
      '/help/permitted-and-prohibited-items/what-items-can-i-sell-on-catawiki'
    ),
  },
  {
    title: t('seller_register.faq.cost_title'),
    content: t('seller_register.faq.cost_content_with_seller_success_fee'),
    link: sellerSuccessFeeHelpUrl(locale),
  },
  {
    title: t('seller_register.faq.paid_title'),
    content: t('seller_register.faq.paid_content'),
    link: LangUri.generateLocalePath(
      locale,
      '/help/most-asked-questions-of-sellers/when-will-i-receive-payment-for-my-sold-lot'
    ),
  },
  {
    title: t('seller_register.faq.rp_title'),
    content: t('seller_register.faq.rp_content'),
    link: LangUri.generateLocalePath(
      locale,
      '/help/estimates-and-reserve-prices/can-i-set-a-minimum-selling-price-reserve-price'
    ),
  },
  {
    title: t('seller_register.faq.experts_title'),
    content: t('seller_register.faq.experts_content'),
    link: LangUri.generateLocalePath(
      locale,
      '/help/experts-and-evaluation/what-is-the-role-of-experts-at-catawiki'
    ),
  },
];
